// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_13CBG","titleSection":"_2jJsB","gstMsg":"O3tT6","controls":"_1h2uw","videoContrls":"_3CujK","gridWidthSection":"_1R_K5"};